<template>
 
    <NavView></NavView>
    <SideBar></SideBar>
    {{this.my}}

    <div class="container-fluid">
        <!-- <h6 class=" font1 font-bold1 colr1 ">Create Customer</h6> -->
        <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/mcustomergroup/index"> Manage Customer Group </router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Customer Group  </h6>



    
        <div class="card font1 ">
            <div class="card-body font1">

                <Form @submit="saveData()" class=" g-3"  :validation-schema="schema" v-slot="{ errors }" >
                    <div class="row ">
                        
                        <CCol md="3">
                            <CFormLabel for="inputName4">Group Name </CFormLabel>
                            <!-- <CFormInput v-model="customer.salesexecutive" type="text" id="inputName4" /> -->
                    
                            <Field name="name" class="form-control" :class="{ 'is-invalid': errors.name}"
                            rules="required" v-model="customer.salesexecutive" />
                            <span class="clr3 ">{{ errors.name }} </span>
                        </CCol>

                        <CCol md="2">
                            <CFormLabel  for="inputState">Rate Type</CFormLabel> 
                           
                             <!-- <Field rules="required" id="inputState" name="group"  /> -->
                             <CFormSelect class=" "  name="name3" id="notificationPreference" v-model="customer.customer_type"  rules="required" >
                                 
                                 <option class="font1">Select Rating Type</option>
                                
                                 <option class="font1">Daily Rate</option>
                                 <option class="font1">Weekend Rate</option>
                                 <option class="font1">Weekly Rate</option>
                                 <option class="font1">Monthly Rate</option>
                                 
                             </CFormSelect>
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                         </CCol>

                        <CCol md="3">
                            <CFormLabel for="inputName4">Amount</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <Field name="discription" v-model="customer.name"   class="form-control" :class="{ 'is-invalid': errors.discription}"
                             rules="required"  />
                            <span class="clr3 " >{{ errors.discription }}</span>
                            
                            
                        </CCol>

                    </div><br>

                    
                   

                    
                    
                    
                  
              
               
                   
                    

                    

                    

                    
                    
                    <CCol class="right1 mt-4">
                       
                    
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                        
                            <CButton  color="success" class="btn1" type="submit"> Update</CButton>
                            <router-link class="line1 btn btn-danger " to="/mcustomergroup/index">Cancel</router-link>
                        </div>
                    </CCol>
                </Form>




            </div>
        </div>


       
        
         
           


    </div>
    <!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
    <!-- <form @submit.prevent="del()" class="" >
     <input type="text" v-model="user.id"  class="form-control" >
     <button  type="" class="btn btn-success" >delete</button>
     </form> -->

</template>

<script>
    import {  CCol, CFormLabel,  CFormSelect, CButton, } from '@coreui/vue';
    import { defineRule,Form, Field  } from 'vee-validate';
    //import httpClient from '@/axios';
    import NavView from '../../components/NavView.vue'
    import SideBar from '../../components/SideBar.vue'
    
  

   
    defineRule('minMax', (value, [min, max]) => {
  // The field is empty so it should pass
  if (!value || !value.length) {
    return true;
  }
  const numericValue = Number(value.length);
  if (numericValue < min) {
    return 'Please enter a valid phone number.';
  }
  if (numericValue > max) {
    return 'Please enter a valid phone number.';
  }
  return true;
});

    defineRule('required', value => {
     if (!value || !value.length) {
    return 'This field is required';
    }
    return true;
    });

    defineRule('email', value => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if  (!/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/.test(value)) {
    
    return 'Please enter valid email address';
    
  }
  return true;
});



    

    export default {
       
        data() {
      
  
        
    
            return {
                isHidden: false,
                count: 0,
                values:{},

                isHidden1: false,
                count1: 0,
                values1:{},
                 

                'customer': {
                    'customer_type' : '',
                    'C_name': '',
                    'C_firstname':'',
                    'C_lastname':'',
                    'district':'',
                    'salesexecutive': '',
                    'nic_no': '',
                    'driving_license': '',
                   
                   
                },

              
               
            };
        },

        // validation:{
        //     customer: {
        //         name:{
        //             required,
        //             minLength: minLength(2),

        //         }



        //     },


        // },


        components: {
            CCol,Field, CFormLabel,  CFormSelect, CButton,Form,NavView,SideBar
        },

        methods: {
            async saveData() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
      console.log(this.customer,this.address,this.bank);
    //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
    //     response => {
    //       console.log(response);
    //      this.item = response.data.success;
           //window.location.reload();
          
      //  }
       
       //)
        
   

    },
        
            
            add: function(){
            this.count++;
            },
            remove: function () {
            this.count--;
     
    },
            add1: function(){
            this.count1++;
            },
            remove1: function () {
            this.count1--;

            },
            // add(){
            //     this.customer.push({
                    // 'contactname': '',
                    // 'contactdis': '',
                    // 'contactemail': '',
                    // 'contactmobile': '',
            //     })

            // },

//             createNewElement() {
//     // First create a DIV element.
// 	var txtNewInputBox1 = document.createElement('div');
// 	var txtNewInputBox2 = document.createElement('div');
// 	var txtNewInputBox3 = document.createElement('div');
// 	var txtNewInputBox4 = document.createElement('div');

//     // Then add the content (a new input box) of the element.
// 	txtNewInputBox1.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox2.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox3.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox4.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";

//     // Finally put it where it is supposed to appear.
// 	document.getElementById("newElementId1").appendChild(txtNewInputBox1);
//     document.getElementById("newElementId2").appendChild(txtNewInputBox2);
//     document.getElementById("newElementId3").appendChild(txtNewInputBox3);
//     document.getElementById("newElementId4").appendChild(txtNewInputBox4);
// },

 





            // saveData() {
                

            //     console.log("ok");
            //     console.log(this.customer);

                




            // }
        }

    };


</script>

<style scoped>
   .font1{
    font-size: 13px !important;
 
  }
  .font-bold1{
    font-weight: bold;
  }
   
    .clr1 {
        background-color: #D4E1E8;
        padding: 2px;
        padding-left: 20px;
    }

    .clr2 {
        background-color: #AED8F2;
        padding: 2px;
        border-radius: 3px
    }

    .right1 {
        text-align: right;
    }

    .btn1 {
        padding-left: 22px;
        padding-right: 22px;
    }

    .clr3 {
        color: red;
    }

    .left1{
        text-align: left;
    }

    .width1{
        width: 25%;
    }
    .width2{
        width: 20%;
    }

    .hiden1 {
        display: none;
    }
    .button2{
        margin-left: 5px;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .body1{
    border-top: 1px solid black;
  }
  .group 			  { 
  position:relative; 
  margin-bottom:10px; 
  
  
}
.input3 				{
  font-size:14px;
  padding:10px 10px 3px 5px;
  display:block;
  width:90%;
  border:none;
  border-bottom:2px solid #999;
}
.input3:focus 		{ outline:none; }

/* LABEL ======================================= */
.label1 				 {
  color:#999; 
  font-size:13px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
}

/* active state */
.input3:focus ~ .label1, .input3:valid ~ .label1 		{
  top:-10px;
  font-size:13px;
  color:#999;
}
</style>